import { css, DefaultTheme } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PageName } from '~/core/enums';
import { SIZES as PLAYOFF_SIZES } from '~/views/pages/dotcom/playoffSeries/components/PlayoffSeriesTable/styles';
import { SIZES as SCHEDULE_SIZES } from '~/views/pages/dotcom/schedule/components/listView/components/dayOverview/styles';

import { centeredFlex, SHARED_SIZES } from './styles';

/**
 * Game Links
 */
export const gameLinksSharedStyle = (theme: DefaultTheme, pageName: PageName) => {
    const SIZES = pageName === PageName.PlayoffSeries ? PLAYOFF_SIZES.gameLinks : SCHEDULE_SIZES.gameLinks;
    return css`
        order: 4;

        ${BaseStyle.Mixins.screenSizes.medium} {
            ${centeredFlex};
            min-width: initial;
            max-width: ${SIZES.iconSize}px;
            width: ${SIZES.iconSize}px;
            position: absolute;
            right: calc(2vw - 3px);

            ${pageName === PageName.PlayoffSeries
                ? 'position: initial'
                : BaseStyle.Mixins.utility.boxShadow(SIZES.shadowSize, theme.Surface.tertiary, [
                      BaseStyle.StyleDirections.left,
                  ])};
        }

        ${BaseStyle.Mixins.screenSizes.large} {
            box-shadow: initial;
            position: initial;
            justify-content: flex-end;
            padding-right: 15px;
        }

        ${BaseStyle.Mixins.screenSizes.extraLarge} {
            min-width: ${SIZES.minSize}px;
            max-width: ${SIZES.maxSize}px;
            width: ${SIZES.size}px;
        }
    `;
};

export const networksStyle = (isPlayoffSeries: boolean) => css`
    order: 3;
    justify-content: center;

    // need to set max-width so we can apply "space-between" to the entire row
    ${BaseStyle.Mixins.screenSizes.large} {
        display: flex;
        justify-content: flex-start;
        max-width: ${isPlayoffSeries ? SHARED_SIZES.network.maxSize + 'px' : 'none'};
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        max-width: none;
    }
`;

export const networksColumnStyle = (isPlayoffSeries: boolean) =>
    css`
        ${BaseStyle.Mixins.fontStyles.desktop.body2}
        ${networksStyle(isPlayoffSeries)}
    `;

export const gameLinksColumnStyle = (theme: DefaultTheme, pageName: PageName) => {
    const SIZES = pageName === PageName.PlayoffSeries ? PLAYOFF_SIZES.gameLinks : SCHEDULE_SIZES.gameLinks;
    return css`
        &.gameLinksColumn.scheduleColumn {
            display: none;

            ${BaseStyle.Mixins.screenSizes.large} {
                display: flex;
            }
        }

        ${BaseStyle.Mixins.screenSizes.medium} {
            background: ${pageName === PageName.PlayoffSeries ? theme.Surface.secondary : theme.Surface.primary};
            max-width: ${SIZES.iconSize}px;
            width: ${SIZES.iconSize}px;
        }

        ${gameLinksSharedStyle(theme, pageName)};
    `;
};
